import useAuthUtilities from '@/AuthMiddleware/AuthUtilities';
import { productApiClient } from '@/clients/ProductAPIClient';
import { AlbumState } from '@/data/models/albumState';
import { IAlbum } from '@/data/models/album';
import { useMutation } from '@tanstack/react-query';

export default function useUpdateProductMutation() {
  const { canUserEditProduct } = useAuthUtilities();

  return useMutation({
    mutationFn: async ({
      albumId,
      album,
      state,
    }: {
      albumId: string | number;
      album: IAlbum;
      state: AlbumState;
    }) => {
      if (!canUserEditProduct(state)) {
        return;
      }

      return await productApiClient.updateProduct(albumId.toString(), album);
    },
  });
}
